export const postData = async (url, data = {}) => {
	const formdata = new FormData()

	Object.entries(data).forEach(([k, v]) => {
		formdata.append(k, v)
	})
	
	try {
		const res = await fetch(url, {
			method: 'POST',
			body: formdata,
			credentials: 'include'})
			
			return await res.json()
	} catch(err) {
		console.log(err)
		return null
	}
}

export const supportsPassiveEvents = () => {
	let passive = false

	try {
		let opts = Object.defineProperty({}, 'passive', {
			get: function() {
				passive = true
			}
		})

		window.addEventListener('testPassive', null, opts)
		window.removeEventListner('testPassive', null, opts)
	} catch(e) {
	}
	
	return passive
}

export const createElement = (type, opts = {}) => {
	const e = document.createElement(type)
	
	if(opts.id) {
		e.id = opts.id
	}

	if(opts.cls) {
		e.className = opts.cls
	}
	
	return e
}

export const hasClass = (element, cls) => {
	if(!element) {
		return false
	}

	if(element.classList) {
		return element.classList.contains(cls)
	} else {
		const re = new RegExp('\\b' + cls + '\\b')
		return re.test(element.className)
	}
}

export const shallowEqual = (a, b) => {
	for(let k in a) {
		if(a[k] !== b[k]) {
			return false
		}
	}

	for(let k in b) {
		if(!(k in a)) {
			return false
		}
	}

	return true
}

export const addClass = (element, cls) => {
	if(!element) {
		return
	}
	
	if(element.classList) {
		element.classList.add(cls)
	} else if(element.className) {
		if(element.className.baseVal) {
			element.className.baseVal += ` ${cls}`
		} else {
			element.className += ` ${cls}`
		}
	}
}

export const removeClass = (element, cls) => {
	if(!element) {
		return
	}
	
	cls.split(/\s/).forEach(c => {
		if(element.classList) {
			element.classList.remove(c)
		} else if(element.className) {
			if(element.className.replace) {
				element.className = element.className.replace(c, '')
			// IE 11 SVG class hack
			} else if(element.className.baseVal) {
				element.className.baseVal = element.className.baseVal.replace(c, '')
			}
		}
	})
}

export const toggleClass = (element, cls) => {
	if(hasClass(element, cls)) {
		removeClass(element, cls)
	} else {
		addClass(element, cls)	
	}
}

export const liveEvent = (element, event_name, selector, cb) => {
	element.addEventListener(event_name, function(event) {
		let target = event.target
		while(target && !hasClass(target, selector)) {
			target = target.parentElement
		}
		
		if(target) {
			cb(target, event)
		}
	})
}

export const isVisible = element => {
	let isvisible = false

	if(!element) {
		return false
	}

	try {
		isvisible = getComputedStyle(element).display !== 'none'
	} catch(err) {
		console.log(err)
	}

	return isvisible
}

export const hasLocalStorage = () => {
	try {
		const s = window.localStorage
		const x = '__storage_test__'
		s.setItem(x, x)
		s.removeItem(x)
	} catch(e) {
		return false
	}

	return true
}

export const isMobileLayout = () => window.matchMedia('(max-width: 32.5em), (orientation: landscape) and (max-height: 32.5em)').matches

export const offset = e => {
	const rect = e.getBoundingClientRect()

	return {
		top: rect.top   + document.body.scrollTop,
		left: rect.left + document.body.scrollLeft
	}
}

export const mkrange = (start, end, step = 1) => {
	var length = Math.ceil((end > start ? end - start : start - end) / step)
	
	const result = Array(length)

	let j = 0
	for(let i = start; i < end; i += step) {
		result[j++] = i
	}
	
	return result
}

export const height = e => {
	const style = getComputedStyle(e)
	return e.offsetHeight + parseInt(style.marginTop) + parseInt(style.marginBottom)
}

export const width = e => {
	const style = getComputedStyle(e)
	return e.offsetWidth + parseInt(style.marginLeft) + parseInt(style.marginRight)
}

export const elementFromTouchEvent = event => {
	let x = null
	let y = null

	if(event.changedTouches) {
		x = event.changedTouches[0].clientX
		y = event.changedTouches[0].clientY
	} else if(event.touches && event.touches.length) {
		x = event.touches[0].clientX
		y = event.touches[0].clientY
	}

	return document.elementFromPoint(x, y)
}

export const isDarkMode = () => window.matchMedia('(prefers-color-scheme: dark)').matches || document.querySelector('body').classList.contains('darkTheme')

export const isFunction = f => !!(f && f.constructor && f.call && f.apply)

export const mapData = (data, key, format_func = null) => data.map(step => format_func ? format_func(step[key]) : step[key])

export const min = (a, b) => a < b ? a : b
export const max = (a, b) => a > b ? a : b
